import { useEffect } from "react";
import { useNavigate } from "react-router";
import { PageHeader } from "@/components/page-header";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { useMe } from "@/lib/hooks/use-clients";
import { useTeams } from "@/lib/hooks/use-teams";
import { useT } from "@/lib/i18n/use-t";
import { hasPermission, type Permission } from "@/lib/permissions";
import { T } from "./page.i18n";
import { TeamsWrapper } from "./teams-wrapper";

export default function TeamsPage() {
  const navigate = useNavigate();
  const t = useT(T);
  const { me, isLoading: meLoading } = useMe();

  const userPermissions = (me?.permissions || ["advisor"]) as Permission[];
  const canAccess = hasPermission(userPermissions, "users");

  const { teams, isLoading } = useTeams({ enabled: !meLoading && canAccess });

  useEffect(() => {
    if (!meLoading && !canAccess) {
      navigate("/", { replace: true });
    }
  }, [meLoading, canAccess, navigate]);

  if (meLoading || !canAccess || isLoading) return null;

  return (
    <div className="space-y-6">
      <PageHeader
        breadcrumbs={[{ label: t.settings, href: "/settings" }, { label: t.teams }]}
        title={t.teams}
        description={t.pageDescription}
      />

      {/* Always shown: teams are used for filtering whatever the access settings (Decision 10). */}
      <Alert>
        <AlertDescription>{t.accessNote}</AlertDescription>
      </Alert>

      <TeamsWrapper teams={teams} />
    </div>
  );
}
